/**
 * O chat na coluna da direita (pedido do Igor, 2026-11-03): aberto pelo botão
 * "Abrir na lateral" da página do chat, fica ao lado de qualquer tela até a
 * pessoa fechar ou voltar à tela cheia. Na própria página do chat ele some
 * (seria o mesmo chat duas vezes, com dois streams).
 */
import { useLocation } from "react-router-dom";

import { useAuth } from "../../context/AuthContext";
import ChatPage from "./index";
import { useChatDaLateral } from "./lateral";

export function useChatNaLateralVisivel() {
  const { aberta } = useChatDaLateral();
  const { hasPermission } = useAuth();
  const { pathname } = useLocation();
  const naPaginaDoChat = pathname === "/chat" || pathname.startsWith("/chat/");
  return aberta && !naPaginaDoChat && hasPermission("chat:view");
}

export function ChatNaLateral() {
  const visivel = useChatNaLateralVisivel();
  if (!visivel) return null;
  return (
    <aside className="pchat-coluna-lateral" aria-label="Chat na lateral">
      <ChatPage naLateral />
    </aside>
  );
}
